import classes from './ResumeTemplate1.module.scss';
import { countries } from 'country-flags-svg';
import { beautifyDate } from 'utils/dateUtils';
import AvatarImage from 'assets/images/avatar-image.png';

const ResumeTemplate1 = ({ data }) => (
  <div className={classes['wrapper']}>
    <div className='row'>
      <div className='col-6'>
        <div className={classes['contact-info']}>
          {data.contact_information.phone_number && (
            <>
              <h3>Contact Number:</h3>
              <span>{data.contact_information.phone_number}</span>
            </>
          )}
          {data.contact_information.email && (
            <>
              <h3>Email:</h3>
              <span>{data.contact_information.email}</span>
            </>
          )}
          {data?.about_me.residential_country_iso && (
            <>
              <h3>Residential Location:</h3>
              <span>{countries.find((crty) => crty.iso2 === data?.about_me.residential_country_iso)?.name || ''}</span>
            </>
          )}

        </div>
      </div>
      <div className='col-6 d-flex justify-content-between align-items-center'>
        <span className={classes['user-name']}>{data.user.first_name}<br /> {data.user.last_name}</span>
        <img className={classes['user-image']} src={data.user.image ? data.user.image : AvatarImage.src} />
      </div>
    </div>

    {
      (data.education?.education?.length > 0 ||
        data.about_me?.languages?.length > 0 ||
        data.skills.software_skills ||
        data.skills.technical_skills ||
        data.work_experience?.work_experiences?.length > 0 ||
        data.certificates?.length > 0) && (
        <div className={classes.container}>
          {/* Left Column */}
          <div className={classes['left-column']}>
            {data.education?.education?.length > 0 && (
              <section className={classes.education}>
                <h2>Education</h2>
                {data.education.education.map((edu) => (
                  <div className='mb-3'>
                    <p><strong>{edu.university}</strong></p>
                    <p>{edu.education_degree.degree}, {edu.field_or_major}</p>                    
                  </div>
                ))}
              </section>
            )}
            {data.about_me?.languages?.length > 0 && (
              <section className={classes.languages}>
                <h2>Language(s)</h2>
                {data.about_me.languages.map((lang) => (
                  <p><strong>{lang?.language?.name}</strong> {lang?.proficiency?.proficiency}</p>
                ))}
              </section>
            )}
            {(data.skills.software_skills || data.skills.technical_skills) && (
              <section className={classes.skills}>
                <h2>Skills</h2>
                {data.skills.software_skills && (
                  <div className='avoid-break'>
                    <h4>Software Skills</h4>
                    <p>{data.skills.software_skills}</p>
                  </div>
                )}
                {data.skills.technical_skills && (
                  <div className='avoid-break'>
                    <h4>Technical Skills</h4>
                    <p>{data.skills.technical_skills}</p>
                  </div>
                )}
              </section>
            )}

          </div>

          {/* Right Column */}
          <div className={classes['right-column']}>
            {data.work_experience?.work_experiences?.length > 0 && (
              <section className={classes['work-experience']}>
                <h2>Work Experience</h2>

                {data.work_experience.work_experiences.map((exp) => (
                  <div className={`${classes.job} avoid-break`}>
                    <h3><strong>{exp.job_title}</strong></h3>
                    <p>{exp.company_name}</p>
                    <p>{beautifyDate(exp.start_date)} - {exp.end_date ? beautifyDate(exp.end_date) : 'Now'} &nbsp;&nbsp;&nbsp; {exp.employment_status.status}</p>
                    <p>{exp.description}</p>
                  </div>
                ))}
              </section>
            )}
            {data.certificates?.length > 0 && (
              <section className={classes.certificates}>
                <h2>Pharmuni Certificates</h2>
                {data.certificates.map((cert) => (
                  <div className={`${classes.certificate} avoid-break`}>
                    <div>
                      <h3>{cert.title}</h3>
                      <p>{cert.certificate_generated_at}</p>
                    </div>
                    <p className={classes['certificate-id']}>Certificate ID: <span>{cert.certificate_id}</span></p>
                  </div>
                ))}
              </section>
            )}
          </div>
        </div>
      )
    }

  </div>
);


export default ResumeTemplate1;